RegCtrl.$inject = ['$scope', 'configs', '$state', 'PortalApi', 'Notification', '$interval', '$translate', 'Analytics','$rootScope', 'Localization', 'Authentication'];

function RegCtrl($scope, configs, $state, PortalApi, Notification, $interval, $translate, Analytics, $rootScope, Localization, Authentication) {
    $scope.registrationStep = '';
    $scope.preLoader = false;
    $scope.smsWrongInput = 0;
    $rootScope.yasno = false;

    $scope.changeStep = function(activeStep) {
        $scope.registrationStep = activeStep;
        if (activeStep == 'registration') {
            $scope.smsWrongInput = 0;
        }
        if (activeStep == 'verifyPhone') {
            $scope.smsCodeError = false;
        }
    };

    $scope.init = function() {
        $scope.changeStep('registration');
    };

    $scope.regForm = {
        login: '',
        password: '',
        email: '',
        phone: '',
        name: '',
        captcha:'',
        options: {}
    };

    $scope.getCookie = function () {
        var aff_sub = "aff_sub=";
        // var aff_id = "aff_id=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(aff_sub) == 0) {
                $scope.regForm.options.salesDoubler = c.substring(aff_sub.length, c.length);
            }
            // if (c.indexOf(aff_id) == 0) {
            //     $scope.regForm.options.aff_id = c.substring(aff_id.length, c.length);
            // }
        }
    }

    if($rootScope.useFrame && $state.current.data.iframe == false){
        document.body.classList.remove('bodyContainer');
        $state.go('pages.error404');
        $rootScope.useFrame = false;
    }

    $scope.activeSliderFormPreLoader = function (active) {

        if (active) {
            $scope.errorFields = [];
        }

        $scope.preLoader = active || false;
    };

    $scope.toStepTwo = function(form) {
        $scope.regForm.login = form.login;
        $scope.regForm.name = form.name;
        $scope.regForm.password = form.password;
        $scope.regForm.email = form.email;
        $scope.regForm.captcha = form.captcha;
        $scope.regForm.phone = String(form.phone).replace(/[^\d]/g, '');

        if($rootScope.admitad_uid) {
            $scope.regForm.options.admitad = $rootScope.admitad_uid;
        }
        $scope.getCookie();
        // $scope.came = 120;
        $scope.avail = false;
        $scope.buttonActive = false;
        $scope.time = {};
        $scope.time.s = "00";
        $scope.time.m = "2";

        $scope.oldTime = new Date().getTime();
        $scope.endTime = Math.floor(($scope.oldTime + 120500) /1000);
        $scope.twoMin = Math.ceil(Math.abs(($scope.endTime - ($scope.oldTime/1000))));

        var value = form.phone.substr(0, 2);
        var config = configs.mobile_codes;

        $scope.tick = function () {

            $scope.timeNow = new Date().getTime();
            $scope.timeNow = Math.floor($scope.timeNow/1000);
            $scope.buttonActive = false;


            if ($scope.timeNow >= $scope.endTime) {
                $interval.cancel($scope.timer);
                $scope.avail = true;
                $scope.time.s = '00';
                $scope.time.m = '0';
                $scope.buttonActive = true;
            } else {
                $scope.twoMin--;
                $scope.time.s = ($scope.twoMin % 60) < 10 ? "0" + $scope.twoMin % 60 : $scope.twoMin % 60;
                $scope.time.m = Math.floor($scope.twoMin / 60);
            }
        };

        $scope.timer = $interval($scope.tick, 1000);


        for (var i = 0; i < config.length; ++i) {
            if (config[i].codes.indexOf(value) != -1) {
                $scope.sendSmsCode(true);
                return;
            }
        }

        Localization.notifyTemplate('error', 'ERRORS.MOBILE_OPERATOR_E', 5, true);
    };

    $scope.sendSmsCode = function(changeStep) {
        var form = angular.copy($scope.regForm);

        form.phone = '380' + form.phone;


        if ($scope.avail) {
            $scope.oldTime = new Date().getTime();
            $scope.endTime = Math.floor(($scope.oldTime + 120500) /1000);
            $scope.twoMin = Math.ceil(Math.abs(($scope.endTime - ($scope.oldTime/1000))));
            // $scope.came = 120;
            $scope.avail = false;
            $scope.timer = $interval($scope.tick, 1000);
            $scope.time.s = "00";
            $scope.time.m = "2";
            $scope.buttonActive = true;
        }

        $scope.activeSliderFormPreLoader(true);

        PortalApi.registryValidateUserData(form).then(function(res) {
            res = res.plain();

            if (res.status == 'success') {

                if (changeStep) {
                    $scope.changeStep('verifyPhone');
                }

                return $translate('REG.CONTIN.SMS_1').then(function(transform1) {
                    return $translate('REG.CONTIN.SMS_2').then(function(transform2) {
                        return Notification.success({
                            message: transform1 + '+380' + $scope.regForm.phone + transform2,
                            delay: 5000
                        });
                    });
                });
            } else {
                $scope.errorFields = res.fields;

                Localization.notifyTemplate('error', 'ERRORS.USER_ALREADY_REGISTERED', 5, true);
            }

        }, function(err) {
            if(err && err.data) {
                switch (err.data.text_сode) {
                    case 'MAX_REQ_PER_PERIOD':
                        Localization.notifyTemplate('error', 'ERRORS.MAX_REQ_PER_PERIOD', 5, true);
                        break;
                    case 'INCORRECT_INCOMING_DATA':
                        Localization.notifyTemplate('error', 'ERRORS.USER_ALREADY_REGISTERED', 5, true);
                        break;
                    default:
                        Localization.notifyTemplate('error', 'ERRORS.UNKNOWN_ERROR', 5, true);
                        break;
                }

            }


        }).finally(function() {
            $scope.activeSliderFormPreLoader();
        });
    };

    $scope.verifySmsCode = function(form) {
        var data   = angular.copy($scope.regForm);
        data.code  = form.code;
        data.phone = '380' + data.phone;

        $scope.activeSliderFormPreLoader(true);

        PortalApi.userRegistry(data).then(
            function (res) {
                res = res.plain();

                if (res.status == 'success') {

                    Localization.notifyTemplate('success', 'NOTIFICATION.SUCCESS.USER_REG_SUCCESS', 10, true);

                    Analytics.trackEvent(
                        'Регистрация',
                        'Успешно',
                        'Перешел на страницу входа',
                        'send', {
                            hitType: 'event',
                            eventCategory: 'thankyoupage',
                            eventAction: $rootScope.lastPayment ? JSON.stringify($rootScope.lastPayment) : ''
                        }
                    );
                    Analytics.pageView();

                    // $state.go('pages.login', {
                    //     registration: true
                    // });
                    $rootScope.admitad_uid = null;

                    data.email = data.login;
                    data.afterRegistration = true;

                    Authentication.login(data).then(function() {
                        // $state.go('pages.mycards', {masterpassStatus: Authentication.user.mp_status, newUser: true});
                        $state.go('pages.mycards', {masterpassStatus: null, newUser: true});
                    });
                } else {
                    $scope.activeSliderFormPreLoader();

                    $scope.smsWrongInput++;

                    Analytics.trackEvent(
                        'Регистрация',
                        'Не успешна',
                        'Не верный ' + $scope.smsWrongInput + ' смс'
                    );
                    Analytics.pageView();

                    $scope.activeSliderFormPreLoader();
                    $scope.smsCodeError = true;
                    Localization.notifyTemplate('error', 'REG.CODE.SMS', 5, true);

                    form.code = '';
                }
            },
            function () {
                $scope.smsWrongInput++;
                $scope.activeSliderFormPreLoader();

                Analytics.trackEvent(
                    'Регистрация',
                    'Не успешна',
                    'Не верный ' + $scope.smsWrongInput + ' смс'
                );
                Analytics.pageView();

                $scope.smsCodeError = true;
                Localization.notifyTemplate('error', 'REG.CODE.SMS', 5, true);
            }
        )
        // .finally(function () {
        //     $scope.activeSliderFormPreLoader();
        // });
    };

    $scope.registration = function () {
        $scope.activeSliderFormPreLoader(true);
        $scope.regForm.phone = '380' + $scope.regForm.phone;
    };

    $scope.init();
}

module.exports = RegCtrl;



/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/registration/controllers/registration.js
 ** module id = 286
 ** module chunks = 1
 **/